module.exports = __webpack_public_path__ + "static/media/agent-man.a4c01109.svg";